const REACT_APP_API_ENDPOINT = `${process.env.REACT_APP_SBMA_ASSETS_API_ENDPOINT}/api/v1`;
const VEHICLE_API_ENDPOINT = REACT_APP_API_ENDPOINT + "/vehicle";


export default {

    LIST_VEHICLE:                           VEHICLE_API_ENDPOINT + "/list",
    CREATE_VEHICLE:                         VEHICLE_API_ENDPOINT + "/create",
    GET_VIEW_VEHICLE:                       VEHICLE_API_ENDPOINT + "/view",
    UPDATE_VEHICLE:                         VEHICLE_API_ENDPOINT + "/update",
    UPDATE_VEHICLE_STATUS:                  VEHICLE_API_ENDPOINT + "/update/status",
    FILTER_VEHICLE:                         VEHICLE_API_ENDPOINT + "/filter/list",
    GET_VEHICLE_ACCESS_LOGS:                VEHICLE_API_ENDPOINT + "/access-logs",
    GET_ACTIVE_VEHICLE_LIST:                VEHICLE_API_ENDPOINT + "/get/list",
    
    // common
    GET_VEHICLE_TYPES:                      VEHICLE_API_ENDPOINT + "/type", 
}